import { em } from 'polished'
import styled, { css } from 'styled-components'

import { Text } from 'styles/components/typography'

const translate = em(50)

export const TextStyled = styled(Text)`
  padding: ${em(40)};

  ${({
    theme: {
      animation: { timeBtns, cubicBezier },
    },
  }) => css`
    transition-duration: ${timeBtns};
    transition-property: opacity, transform;
    transition-timing-function: ${cubicBezier};
  `}

  ${({ status }) =>
    status === 'entering' &&
    css`
      opacity: 0;
      transition-duration: 0s;
      transform: translateY(${translate});
    `}

  ${({ status }) =>
    status === 'entered' &&
    css`
      opacity: 1;
      transform: translateY(0);
      transition-duration: ${p => p.theme.animation.timeBtns};
    `}

  ${({ status }) =>
    (status === 'exiting' || status === 'exited') &&
    css`
      position: absolute;
      top: ${em(40)};
      opacity: 0;
      transform: translateY(${translate});
    `}
`
